import { render, staticRenderFns } from "./GroupVersionCreator.vue?vue&type=template&id=00e94ccc"
import script from "./GroupVersionCreator.vue?vue&type=script&lang=js"
export * from "./GroupVersionCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupVersionCreator.vue
// module id = 221
// module chunks = 0